import React, { useState } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Grid,
  Switch,
  FormControlLabel
} from '@material-ui/core';
import api from './api';
import { toast } from 'react-toastify';

const CategoryManager = ({ siteData, refetch }) => {
  const s3_site_url = 'https://d6-halo.s3.us-east-2.amazonaws.com/static/media/categories/';
  const [processing, setProcessing] = useState(false);

  const [categories, setCategories] = useState(
    siteData?.categories?.length
      ? siteData.categories.map(cat => ({
          id: cat.id,
          site: siteData.ID,
          name: cat.name || '',
          image: cat.imageN || null,
          priority:cat.priority||1,
          imagePreview: cat.imageN ? s3_site_url + cat.imageN : null,
          active: cat.active !== false,
        })).sort((a,b)=>a.id>b.id?1:-1)
      : [{
          site: siteData?.ID,
          name: '',
          image: null,
          imagePreview: null,
          active: true
        }]
  );
const [active,setActive]=useState('')

  const handleChange = (index, e) => {
    const { name, value, type, files, checked } = e.target;
    const updated = [...categories];

    if (type === 'file') {
      const file = files[0];
      updated[index].image = file;
      updated[index].imagePreview = URL.createObjectURL(file);
    } else if (type === 'checkbox') {
      updated[index][name] = checked;
    } else {
      updated[index][name] = value;
    }

    setCategories(updated);
  };

  const handleAddCategory = () => {
 if(categories.length<siteData.max_categories) {  setCategories([
      ...categories,
      {
        site: siteData?.ID,
        name: '',
        image: null,
        imagePreview: null,
        active: true,
        priority:1
      }
    ]);}

    else{
            toast.error(`Max ${siteData.max_categories} categories are allowed`)
      
    }
  };

  const handleSubmit = async (index) => {
    const formData = new FormData();
    const category = categories[index];


setActive(index)
  if (!category.name?.trim()) {
    toast.error(`Category #${index + 1}: Name is required`);
    return;
  }

  
  if (!category.id && (!category.image || !category.image.name)) {
    toast.error(`Category #${index + 1}: Image is required for new category`);
    return;
  }

    Object.entries(category).forEach(([key, value]) => {
      if (key === 'imagePreview') return;

      if (key === 'image') {
        if (value && value.name) {
          formData.append('image', value); // Only new file
        }
      } else {
        formData.append(key, value);
      }
    });

    setProcessing(true);
    try {
      if (category.id) {
        formData.append('id', category.id);
        await api.put('category-v2', formData);
        toast.success(`Category #${index + 1} updated`);
      } else {
        await api.post('category-v2', formData);
        toast.success(`Category #${index + 1} created`);
      }

      refetch?.();
    } catch (err) {
      console.error(err);
      toast.error(
        `Error ${category.id ? 'updating' : 'creating'} category #${index + 1}`
      );
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Paper style={{ padding: 20 }}>
      <Typography variant="h6">Manage Categories</Typography>

      {categories.map((category, index) => (
        <Paper key={index} style={{ padding: 16, marginBottom: 20, background: '#f9f9f9' }}>
          <Typography variant="subtitle1">Category #{index + 1}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ textAlign: 'right' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={category.active}
                    onChange={(e) => handleChange(index, e)}
                    name="active"
                    color="primary"
                  />
                }
                label="Active"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Site"
                name="site"
                value={category.site}
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Category Name"
                required
                name="name"
                value={category.name}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            <Grid item xs={12}>
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>

            {(category.imagePreview ||
              (typeof category.image === 'string' && category.image)) && (
              <Grid item xs={12}>
                <img
                  src={
                    category.imagePreview
                      ? category.imagePreview
                      : s3_site_url + category.image
                  }
                  alt={`Preview #${index + 1}`}
                  style={{ maxWidth: '100%', maxHeight: 200, marginTop: 10 }}
                />
              </Grid>
            )}



  <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Category Priority"
                required
                name="priority"
                value={category.priority}
                onChange={(e) => handleChange(index, e)}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSubmit(index)}
                disabled={processing}
              >
                {processing&&index===active
                  ? 'Processing...'
                  : category.id
                  ? `Update Category #${index + 1}`
                  : `Submit Category #${index + 1}`}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      ))}

      <Button
        variant="contained"
        color="primary"
        onClick={handleAddCategory}
      >
        + Add Category
      </Button>
    </Paper>
  );
};

export default CategoryManager;
